/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'vintage-wall-clock-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M12.5 0A12.5 12.5 0 1 0 25 12.5 12.5 12.5 0 0 0 12.5 0zM12 2.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0zM3.5 13h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zm2.99 6.218l-.707.707a.5.5 0 0 1-.707-.707l.707-.708a.5.5 0 0 1 .707.707zm0-12.728a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 .707-.707l.707.707a.5.5 0 0 1 0 .707zM13 22.5a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 1 0zm4.5-9.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0V12h4.5a.5.5 0 0 1 0 1zm2.425 6.925a.5.5 0 0 1-.708 0l-.707-.707a.5.5 0 0 1 .707-.708l.708.708a.5.5 0 0 1 0 .707zm0-14.143l-.708.707a.5.5 0 0 1-.707-.707l.707-.707a.5.5 0 1 1 .708.707zM22.5 13h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1z"/>'
  }
})
